module.exports = __webpack_public_path__ + "img/ml.39951d9e.svg";